import axiosInstance from "./axiosInstance";

const getImpact = async (clientId: string) =>
  axiosInstance.get(`/v3/${clientId}/impact`);

export default getImpact;
